<template>
    <main class="mt-5">
        <span id="add-btn" class="not-in-print">
            <button :disabled="hasPermission('write_store') ? false : true" type="button" tabindex="-1"
                class="btn btn-success" @click="incrementModal()">
                افزایش
            </button>
            <button :disabled="hasPermission('write_store') ? false : true" type="button" tabindex="-1"
                class="btn btn-danger mr-2" @click="decrementModal()">
                کاهش
            </button>
        </span>
        <b-tooltip v-if="!hasPermission('write_store')" target="add-btn" triggers="hover">
            شما به این بخش دسترسی ندارید
        </b-tooltip>
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">انبار</h5>
                <div style="flex:1"></div>
                <button @click="print" class="btn btn-primary">
                    <span
                        style="transform: translateY(3px)"
                        class="feather-printer"
                    ></span>
                </button>
            </div>
            <b-card class="not-in-print">
                <div class="row mt-2">
                    <div class="col-6 mb-1">
                        <multiselect placeholder="انتخاب انبار" v-model="selectedStore" open-direction="bottom"
                            :options="stores" label="label" track-by="value" :searchable="true" :close-on-select="true"
                            :show-labels="false" :disabled="disabled">
                            <template slot="noOptions">
                                موردی یافت نشد
                            </template>
                            <template slot="noResult">
                                موردی یافت نشد
                            </template>
                        </multiselect>
                    </div>
                    <ProductSearch class="col-md-12 row" :selectable="true" :disabled="disabled"
                                @selectProduct="selectProduct" @selectVariety="selectVariety" />
                    <b-form-group class="col-md-4">
                        <multiselect placeholder="نوع تغییرات" v-model="filter.type" open-direction="bottom"
                            :options="typeOptions" label="title" track-by="value" :searchable="true"
                            :close-on-select="true" :show-labels="false" :disabled="disabled">
                            <template slot="noOptions">
                                موردی یافت نشد
                            </template>
                            <template slot="noResult">
                                موردی یافت نشد
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group class="col-md-4">
                        <date-picker placeholder="از تاریخ" v-model="filter.start_date" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" />
                    </b-form-group>
                    <b-form-group class="col-md-4">
                        <date-picker placeholder="تا تاریخ" v-model="filter.end_date" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" />
                    </b-form-group>
                </div>
                <div class="text-center mt-1">
                    <button :disabled="disabled" @click="doFilter"  class="btn btn-primary px-5">جستجو</button>
                    <button  
                        :disabled="disabled"  
                        type="reset"  
                        @click="resetFilters"  
                        class="btn btn-warning px-5 mr-3"  
                    >  
                        برداشتن فیلتر  
                    </button>  
                </div>
            </b-card>
            <div class="card-body" id="print">
                <div>
                    <b-table v-if="items.data.length" responsive hover bordered :items="items.data" :fields="fields">
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate}}
                        </template>
                        <template v-slot:cell(admin_name)="data">
                            <span v-if="data.item.admin">{{data.item.admin.name}}</span>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:cell(store_name)="data">
                            {{data.item.store.label}}
                        </template>
                        <template v-slot:cell(product)="data">
                            {{data.item.store_item.variety.title}}
                        </template>
                        <template v-slot:cell(type)="data">
                            <span v-if="data.item.type == 'increment'" class="badge badge-success status">افزایش</span>
                            <span v-else class="badge badge-danger status">کاهش</span>
                        </template>
                    </b-table>
                    <div v-else class="alert alert-danger">
                        موردی یافت نشد
                    </div>
                    <Loading v-if="$root.isEmptyObject(items)" />
                    <pagination class="not-in-print" v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                        @pagination-change-page="changePage">
                    </pagination>
                </div>
            </div>
        </div>
        <StoreModal :stores="stores" :mode="mode" v-model="store" @dataSubmitted="handleDataSubmitted"/>  
    </main>
</template>
<script>
import StoreImpl from '@@/core/pages/Store/StoreImpl'
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
export default {
    components: {ProductSearch},
    extends: StoreImpl
}
</script>

<style scoped>
@media print {
    .not-in-print {
        display: none !important;
    }
    #print {
        width: 100%;
    }
    #print button {
        position: static;
        left: 0;
        bottom: 0;
    }
}
#print button {
    position: static;
    left: 0;
    bottom: 0;
}
</style>